/**
 * Copyright © 2025 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

import React, { useEffect } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Loader from './components/Loader';
import Toaster from './components/Toaster';
import { useAuth } from './context/AuthContext';
import { useLoader } from './context/LoaderContext';
import { setGlobalLoaderSetter } from './api';

import PropTypes from 'prop-types';

function MainLayout({ children }) {
    const { isLoggedIn } = useAuth();
    const { loading, setLoading } = useLoader();

    useEffect(() => {
        setGlobalLoaderSetter(setLoading);
    }, [setLoading]);

    return (
        <>
            {isLoggedIn && <Header />}
            <Toaster />
            {loading && <Loader />}
            <main style={{ minHeight: '80vh' }}>{children}</main>
            <Footer />
        </>
    );
}

MainLayout.propTypes = {
    children: PropTypes.node,
};

export default MainLayout;
